// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Store = require("../../../shared/src/Store.bs.js");
var IOUtils = require("../../../shared/src/IOUtils.bs.js");
var DomUtils = require("../../../shared/src/DomUtils.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var WebStore_Reducer = require("./WebStore_Reducer.bs.js");
var WebStore_Types_State = require("./WebStore_Types_State.bs.js");
var WebStore_Types_Action = require("./WebStore_Types_Action.bs.js");

var include = Store.Make({
      initialState: WebStore_Types_State.initialState,
      reducer: WebStore_Reducer.reducer
    });

var dispatch = include.dispatch;

var partial_arg = Curry._1(Relude_IO.mapError, (function (prim) {
        
      }));

IOUtils.unsafeRunHandledAsync(Relude_IO.flatMap((function (param) {
            return Relude_Globals.$great$great((function (param) {
                          return Relude_Globals.$great$great(WebStore_Types_Action.updateFromUrl, dispatch, param);
                        }), partial_arg, param);
          }), DomUtils.Router.dangerouslyGetInitialUrl));

var getState = include.getState;

var unsubscribe = include.unsubscribe;

var subscribe = include.subscribe;

var useState = include.useState;

var useDispatch = include.useDispatch;

var Provider = include.Provider;

exports.getState = getState;
exports.dispatch = dispatch;
exports.unsubscribe = unsubscribe;
exports.subscribe = subscribe;
exports.useState = useState;
exports.useDispatch = useDispatch;
exports.Provider = Provider;
/* include Not a pure module */
